// Coaching block schema - Embeds the full coaching page experience
export const coachingSchema = {
  type: 'coaching',
  label: 'Coaching',
  description: 'Your complete coaching page with lessons, pricing, and FAQ',
  icon: 'GraduationCap',
  defaultContent: {
    enabled: true,
    startExpanded: false,
    style: {},
  },
  fields: [],
};
